import { Component, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { AppErrorMessagesComponent } from 'src/app/base/error-messages/app-error-messages.component';
import { AcodisWorkflowDTO, FilterDTO, FilterOperator, ImportType, SortDirection } from 'src/app/base/models/models.swagger.generated';
import { ImportConfigurationEditFormsCoordinatorService } from '../../import-configuration-edit-forms-coordinator.service';
import { AcodisWorkflowService } from 'src/app/domain/import-configuration/acodis-workflow/acodis-workflow.service';
import { ImportConfigurationAcodisFormType } from '../../configuration-form-acodis/configuration-form-acodis-form-type';

@Component({
    selector: 'app-file-acodis',
    templateUrl: './file-acodis.component.html',
    styleUrls: ['./file-acodis.component.scss'],
    imports: [AppErrorMessagesComponent, ReactiveFormsModule, TranslateModule, DropDownListModule]
})
export class FileAcodisComponent implements OnInit {

  public get configurationFormFileAcodis(): FormGroup<ImportConfigurationAcodisFormType> {
    return this.formsCoordinationService.configurationFormAcodis;
  }

  public fields = { text: 'name', value: 'id' };

  constructor(
    private formsCoordinationService: ImportConfigurationEditFormsCoordinatorService,
    private acodisWorkflowService: AcodisWorkflowService) { }

  public acodisWorkflows: AcodisWorkflowDTO[];
  
  ngOnInit() {
    this.loadAcodisWorkflows();
    this.formsCoordinationService.configurationFormGeneral.controls.importType.valueChanges.subscribe(() => {
      this.loadAcodisWorkflows();
    });
    // make category field optional
    this.configurationFormFileAcodis.controls.category.setValidators(null);
  }

  private loadAcodisWorkflows() {
    const importType: ImportType = this.formsCoordinationService.configurationFormGeneral.controls.importType.value as ImportType;
    if (importType != null) {
      const filter = [new FilterDTO({ isComplex: false, field: 'ImportType', operator: FilterOperator.Equal, value: importType.toString() })];
      this.acodisWorkflowService.getData(0, 0, filter, 'name', SortDirection.Ascending).subscribe(pagedItems => {
        this.acodisWorkflows = pagedItems.items as AcodisWorkflowDTO[];
        if (this.acodisWorkflows.length > 0) {
          if (!this.configurationFormFileAcodis.controls.acodisWorkflowId.value) {
            this.configurationFormFileAcodis.controls.acodisWorkflowId.setValue(this.acodisWorkflows[0].id);
          }
          else if (this.acodisWorkflows.find(x => x.id == this.configurationFormFileAcodis.controls.acodisWorkflowId.value) == undefined) {
            this.configurationFormFileAcodis.controls.acodisWorkflowId.setValue(this.acodisWorkflows[0].id);
          }
        }
      });
    }
  }
}
